export default {
  install(Vue) {
    Vue.prototype.$reorderMetadata = function() {
      console.log("Réorganisation des métadonnées..."); // Pour le débogage
      setTimeout(() => {
        const desiredOrder = [
          'version',
          'mission',
          'instruments',
          'bands',
          'acknowledgment',
          'Additional_contributors',
        ];

        document.querySelectorAll('section.metadata-rows').forEach(section => {
          const rows = Array.from(section.querySelectorAll('.row'));
          rows.sort((a, b) => {
            const titleA = a.querySelector('[title]')?.getAttribute('title') || '';
            const titleB = b.querySelector('[title]')?.getAttribute('title') || '';
            const indexA = desiredOrder.includes(titleA) ? desiredOrder.indexOf(titleA) : Infinity;
            const indexB = desiredOrder.includes(titleB) ? desiredOrder.indexOf(titleB) : Infinity;
            return indexA - indexB;
          });
          rows.forEach(row => section.appendChild(row));
        });
      }, 0);
    };
  }
};

